/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) =>
  state?.ticketGroupsState || initialState;

export const selectTicketGroups = createSelector(
  [selectDomain],
  (state) => state.groups,
);

export const selectTicketCreateLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading,
);

export const selectGroupForm = createSelector(
  [selectDomain],
  (state) => state.groupForm,
);

export const selectTicketFormDetail = createSelector(
  [selectDomain],
  (state) => state.ticketFormData,
);
export const selectGroupingLoader = createSelector(
  [selectDomain],
  (state) => state.groupingLoader,
);
export const selectGroupingTicketsLoader = createSelector(
  [selectDomain],
  (state) => state.groupingTicketsLoader,
);
export const selectTicketCache = createSelector(
  [selectDomain],
  (state) => state.ticketCache,
);
export const selectShowCreateTicketIntoGroup = createSelector(
  [selectDomain],
  (state) => state.showCreateTicketIntoGroup,
);
export const selectGroupsPagination = createSelector(
  [selectDomain],
  (state) => state.groupsPagination,
);
export const selectIsSubgroupCollapsed = createSelector(
  [selectDomain],
  (state) => state.isSubgroupCollapsed,
);

export const selectAllTicketIdAndName = createSelector(
  [selectDomain],
  (state) =>
    state?.groups?.flatMap(
      (group) =>
        group?.ticketsList
          ?.filter((ticket) => !!ticket?._id)
          ?.map((ticket) => ({
            _id: ticket?._id,
            ticketName: ticket?.ticketName,
          })) ?? [],
    ),
);
